import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04f669f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-toast-icon-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.iconWrapClasses)
    }, [
      _createVNode(_component_oxd_icon, {
        name: _ctx.iconName,
        class: "oxd-toast-icon"
      }, null, 8, ["name"])
    ], 2)
  ]))
}